import { createActions } from 'redux-actions';

import { Collaboration } from '@models/Collaboration';
import { GetAllCollaborationParams, CreateCollaborationParams, DeleteCollaborationParams } from '@apis/CollaborationApi';
import { Pagination } from '@models/Pagination';

export type State = {
  collaborations?: Collaboration[] | null;
  pagination?: Pagination;
  isLoading: boolean;
  isReload: boolean;
  isSuccess: boolean;
  serverErrors: object;
};

export type CollaborationsFetchPayload = GetAllCollaborationParams;
export type CollaborationCreatePayload = CreateCollaborationParams;
export type CollaborationDeletePayload = DeleteCollaborationParams;
export type StateUpdatePayload = Partial<State>;

export const {
  collaborationsFetch,
  collaborationCreate,
  collaborationDelete,
  stateUpdate,
  stateClear,
  stateReload,
} = createActions(
  'COLLABORATIONS_FETCH',
  'COLLABORATION_CREATE',
  'COLLABORATION_DELETE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  'STATE_RELOAD',
  {
    prefix: 'FEATURE_COLLABORATION',
  },
);
